import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;

  h2 {
    font-size: 16px;
    color: var(--gray);

    margin-bottom: 8px;
  }

  label {
    width: 100%;
  }

  section {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    margin-bottom: 12px;
    padding-top: 12px;
  }

  section + section {
    margin-top: 0px;
    border-top: #e0e0e0 solid 1px;
  }

  footer {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  button {
    width: 100%;
  }
`

export const DrawerTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: var(--gray);
`

export const ButtonInfo = styled.button`
  border: none;
  background: transparent;
  height: fit-content;
  position: relative;
  top: 12px;

  img {
    z-index: 5;
    width: 16.67px;

    :hover {
      transform: scale(1.2);
    }
  }
`
